import setAttr from './setAttr';

import type { TypeAttrData } from './types';

// ----------------------------------------------------------------------------

function setAttrData(element: HTMLElement, data: TypeAttrData): void {
    // Foreach Attr
    for (const key of Object.keys(data)) {
        const value = data[key];

        setAttr(element, key, value);
    }
}

// ----------------------------------------------------------------------------

export default setAttrData;
